import React, { Component } from "react";
import {
  Card,
  Wrapper,
  ExternalImage,
  Button
} from "app/NativeComponents/common";
import CustomMarker from "app/DealMachineCore/components/PropertyMap/CustomMarker";

import { openMap, AppConfig } from "app/NativeActions";

class LocationMap extends Component {
  handlePress() {
    const {
      property: {
        location: { latitude, longitude },
        property_address_full
      }
    } = this.props;

    if (this.props.device === "desktop") {
      window.open(
        `https://www.google.com/maps/place/${property_address_full}/@=${latitude},${longitude},18z`,
        "_blank"
      );
    } else {
      openMap({
        latitude,
        longitude
      });
    }
  }

  render() {
    const { map_image } = this.props.property;
    if (!!map_image) {
      return (
        <Button onPress={this.handlePress.bind(this)}>
          <Card style={{ position: "relative" }}>
            <ExternalImage
              style={{
                height: 200,
                width: "100%"
              }}
              image={map_image}
            />
            <Wrapper
              style={{
                position: "absolute",
                top: 0,
                bottom: 0,
                right: 0,
                left: 0,
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <CustomMarker dumb_marker={true} device={this.props.device} />
            </Wrapper>
          </Card>
        </Button>
      );
    }

    return <Wrapper />;
  }
}

export default LocationMap;
